import { MediaPlayer, MediaPlayerClass } from 'dashjs';
import { createContext, useContext, useMemo } from 'react';

const DashContext = createContext<{
  player: MediaPlayerClass | null;
}>({
  player: null,
});

const DashUtilsContext = createContext<{
  timeAsUTC: () => number;
}>({
  timeAsUTC: () => NaN,
});

export const useDash = () => useContext(DashContext);
export const useDashUtils = () => useContext(DashUtilsContext);

export function DashProvider({ children }: React.PropsWithChildren) {
  const player = useMemo(() => {
    const mediaPlayer = MediaPlayer().create();
    mediaPlayer.initialize();
    return mediaPlayer;
  }, []);

  const timeAsUTC = () => {
    return player.timeAsUTC();
  };

  return (
    <DashContext.Provider value={{ player }}>
      <DashUtilsContext.Provider
        value={{
          timeAsUTC,
        }}
      >
        {children}
      </DashUtilsContext.Provider>
    </DashContext.Provider>
  );
}
